import { IonButton, IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { MouseEventHandler } from 'react';
import styles from './RemoveIconButton.module.css';

interface RemoveIconButtonProps {
    ariaLabel: string;
    onClick: MouseEventHandler<HTMLIonButtonElement>;
    /** Ionicon to show; defaults to a close cross. */
    icon?: string;
    slot?: string;
}

/** Small round tinted-red destructive icon button used at the end of list rows. */
const RemoveIconButton: React.FC<RemoveIconButtonProps> = ({ ariaLabel, onClick, icon = closeOutline, slot }) => (
    <IonButton slot={slot} className={styles.removeButton} aria-label={ariaLabel} onClick={onClick}>
        <IonIcon slot="icon-only" icon={icon} />
    </IonButton>
);

export default RemoveIconButton;
